<template>
  <div class="Bulletin">
    <div class="economs flex_left">
      <cardsList></cardsList>
      <div class="right_center">
        <div class="flex_left">
          <div class="kontribuo">
            <div class="qikan_instar">
              <div class="journal">
                <h3>
                  {{ jous_list.name }} <span>{{ jous_list.coreName }}</span>
                </h3>
                <p style="margin-top: 10px">
                  CN：<span>{{ jous_list.cn }}</span>
                </p>
                <p>
                  ISSN: <span>{{ jous_list.issn }}</span>
                </p>
                <p>
                  出版周期: <span>{{ jous_list.publishPeriod }}</span>
                </p>
                <p>
                  主管单位: <span>{{ jous_list.responsibleDept }}</span>
                </p>
                <p>
                  主办单位:
                  <span>{{ jous_list.organizer }}</span>
                </p>
                <p>
                  出版单位: <span>{{ jous_list.publishCompany }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="right_kotribuo">
            <!-- <div class="contribute" @click="zaixian()">
              <img src="@/assets/image/zaixiantougao.png" />
              <h3>在线投稿</h3>
            </div> -->

            <!-- <div class="contribute" style="margin-top: 20px">
              <img style="width: 80px; height: 80px" src="@/assets/image/qrcode.png" />
              <p>期刊公众号</p>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <Modal
      v-model="gitHave"
      width="700px"
      class-name="vertical-center-modal"
      :mask-closable="false"
      :closable="false"
      @on-cancel="cancel"
    >
      <div style="min-height: 100px" class="git_have">
        <div class="livest">
          <p style="text-align: center; margin-top: 40px">
            《{{ jous_list.name }}期刊》尚未开通中文知识网融合出版服务平台.
          </p>
          <p style="text-align: center">
            如果您是作者想给本刊投稿或查询进度，请与编辑部直接联系！
          </p>
        </div>

        <Button @click="cancel">关闭</Button>
      </div>

      <div slot="footer"></div>
    </Modal>
    <Modal
      v-model="gitlist"
      width="400px"
      class-name="vertical-center-modal"
      :mask-closable="false"
      :closable="false"
      @on-cancel="cancive"
    >
      <p style="text-align: center; padding: 40px 0px">
        您的账号暂无认证，请认证后再投稿!
      </p>

      <div style="padding-bottom: 50px">
        <Button style="margin-left: 33%" @click="cancive">关闭</Button>
        <Button type="primary" style="margin-left: 3%" @click="liveGive"
          >验证</Button
        >
      </div>
    </Modal>
    <annCement></annCement>
    <modalfiles
      v-if="listGive"
      :listGive="listGive"
      @gitlist="gitlist2"
    ></modalfiles>
  </div>
</template>
<script>
var vm;
import cardsList from "../../components/card_list.vue";
import annCement from "./Announcement/index.vue";
import modalfiles from "../../components/Modal_fiels";
export default {
  name: "Bulletin",
  data() {
    return {
      jous_list: [],
      coverImg: "",
      list_Data: [],
      gitHave: false,
      gitlist: false,
      listGive: false,
    };
  },
  components: { cardsList, annCement, modalfiles },
  computed: {  
    status() {  //  计算属性
      return this.$store.state.eventStatus; //  Vuex 中定义的属性
    }
  },
  watch:{
    status() {
      var linkName = this.$store.state.linkName;
      var linkType = this.$store.state.linkType;
      if(linkName == 'touGao'){
        this.zaixian();
        if(linkType){
          setTimeout(()=>{
              this.$store.state.linkType = false;
              location.reload();
          },500)
        }
      }else if(linkName == 'jinDu'){
        this.soclves();
        if(linkType){
          setTimeout(()=>{
              this.$store.state.linkType = false;
              location.reload();
          },500)
        }
      }
    }
  },
  created() {
    vm = this;
  },
  mounted() {
    vm.jourShow();
    vm.deataKive();
  },
  methods: {
    gitlist2(names) {
      this.listGive = names;
    },
    cancive() {
      this.gitlist = false;
    },
    liveGive() {
      this.gitlist = false;
      this.$router.push({
        path: "/cardHolder",
        query: {
          perName: 4,
          editId: this.$store.state.cbianId,
          perId: this.$store.state.qikanId,
        },
      });
    },
    cancel() {
      this.gitHave = false;
    },
    deataKive() {
      //登录之后如果userid有就传，登录之前就没有1440845449643823104
      var token = this.$store.state.token;
      if (token) {
        var data = {
          editId: this.$store.state.cbianId,
          perId: this.$store.state.qikanId,
          userId: this.$store.state.userId,
          username: this.$store.state.userName,
        };
      } else {
        var data = {
          editId: this.$store.state.cbianId,
          perId: this.$store.state.qikanId,
        };
      }
      vm.$apis.manage.detailsLive(data).then((res) => {
        vm.list_Data = res.data;
      });
    },
    zaixian() {
      var urlList = "";
      if (
        location.host.indexOf("cbtest.") != -1 ||
        location.host.indexOf("127.") != -1 ||
        location.host.indexOf("localhost") != -1
      ) {
        urlList = "https://dev.1cnknowledge.com/newtsgweb/?token="; //
      } else if (location.host.indexOf("yucard") != -1) {
        urlList = "https://yutsg.cnknowledge.com/newtsgweb?token="; //
      } else {
        urlList = "https://publish.cnknowledge.com/newtsgweb?token="; //
      }
      // var urlList =
      //   location.host.indexOf("cbtest.") != -1 || location.host.indexOf(":80") != -1
      //     ? "http://dev.cnknowledge.com/newtsgweb/?token="
      //     : "http://publish.cnknowledge.com/newtsgweb?token=";
      var token = window.sessionStorage.getItem("token");
      var perName = this.jous_list.name;
      if (token) {
        vm.$apis.manage.getUserInfo().then((res) => {
          var list_name;
          // var list_name = res.content.detail.userInfo.nickname
          //   ? res.content.detail.userInfo.nickname
          //   : res.content.detail.userInfo.realname
          //   ? res.content.detail.userInfo.realname
          //   : res.content.detail.userInfo.mobile;
          if (res.content.detail.userInfo) {
            if (res.content.detail.userInfo.nickname) {
              list_name = res.content.detail.userInfo.nickname;
            } else if (res.content.detail.userInfo.realname) {
              list_name = res.content.detail.userInfo.realname;
            } else if (res.content.detail.userInfo.mobile) {
              list_name = res.content.detail.userInfo.mobile;
            }
          } else {
            this.$Message.destroy();
            setTimeout(function () {
              vm.$Message.error("请完善您的个人信息");
            }, 500);
            vm.listGive = true;
            return;
          }
          if (list_name) {
            // if (!res.content.detail.userInfo.idCard) {
            //   this.gitlist = true;
            //   return;
            // }
            if (this.jous_list.contribute == 0) {
              this.gitHave = true;
            } else {
              this.gitHave = false;
              // console.log(vm.list_Data);
              // return;
              // if (vm.list_Data.editType == 1) {
              //   var mywin = window.open(
              //     `${urlList}&prid=${
              //       this.$store.state.qikanId
              //     }#/manage/notice?perName=${perName}&name=${
              //       vm.list_Data.name
              //     }&preliminaryId=${vm.list_Data.preliminaryId}&userId=${
              //       vm.list_Data.userId
              //     }&solicitName=${""}`
              //   );
              // } else if (vm.list_Data.editType == 2) {
              //   var mywin = window.open(
              //     `${urlList}&prid=${this.$store.state.qikanId}#/manage/notice?perName=${perName}&name=${vm.list_Data.dockingEditName}&solicitName=${vm.list_Data.name}&userId=${vm.list_Data.dockingEditId}&preliminaryId=${vm.list_Data.preliminaryId}&solicitId=${vm.list_Data.userId}`
              //   );
              // }
              if (vm.list_Data.editType == 1) {
                var mywin = window.open(
                  `${urlList}&editId=${this.$store.state.cbianId}&prid=${this.$store.state.qikanId}#/manage/author?perName=${perName}`
                );
              } else if (vm.list_Data.editType == 2) {
                var mywin = window.open(
                  `${urlList}&prid=${this.$store.state.qikanId}#/manage/author?perName=${perName}&name=${vm.list_Data.dockingEditName}&solicitName=${vm.list_Data.name}&userId=${vm.list_Data.dockingEditId}&preliminaryId=${vm.list_Data.preliminaryId}&solicitId=${vm.list_Data.userId}`
                );
              }
              mywin.location.reload(true);
            }
          } else {
            this.$Message.destroy();
            setTimeout(function () {
              vm.$Message.error("请完善您的个人信息");
            }, 500);
          }
        });
      } else {
        this.$root.Bus.$emit("analy", true);
        this.$Message.destroy();
        // setTimeout(function () {
        //   vm.$Message.error("请登录您的用户");
        // }, 500);
      }

      // http://dev.cnknowledge.com/newtsgweb/?token=undefined&prid=1297783010043576320#/manage/author
    },
    soclves() {
      // var token = this.$store.state.token || window.sessionStorage.getItem("token", token);
      // if (token) {
      //   if (this.jous_list.contribute == 1) {
      //     vm.$router.push({
      //       path: "/cardHolder",
      //       query: {
      //         perName: 3,
      //         editId: this.$store.state.cbianId,
      //         perId: this.$store.state.qikanId,
      //       },
      //     });
      //   } else {
      //     this.gitHave = true;
      //   }
      // } else {
      //   this.$root.Bus.$emit("analy", true);
      //   vm.$Message.error("请登录您的用户");
      // }
     var token = window.sessionStorage.getItem("token", token);
      var urlList = "";
      if (token) {
        vm.$apis.manage.getUserInfo().then((res) => {
          if(res.resultCode == 200){
            if (
              location.host.indexOf("cbtest.") != -1 ||
              location.host.indexOf("127.") != -1 ||
              location.host.indexOf("localhost") != -1
            ) {
              urlList = "https://dev.cnknowledge.com/newtsgweb/?token="; //
            } else if (location.host.indexOf("yucard") != -1) {
              urlList = "https://yutsg.cnknowledge.com/newtsgweb?token="; //
            } else {
              urlList = "https://publish.cnknowledge.com/newtsgweb?token="; //
            }
            var mywin = window.open(
              `${urlList}&editId=${this.$store.state.cbianId}&prid=${this.$store.state.qikanId}#/manage/mySubmission`
            );
            mywin.location.reload(true);
          }
        })
      }else {
        this.$root.Bus.$emit("analy", true);
        // vm.$Message.error("请登录您的用户");
      }
    },
    //论文推荐列表
    // zaixian() {
    //   var urlList = "";
    //   if (
    //     location.host.indexOf("cbtest.") != -1 ||
    //     location.host.indexOf("127.") != -1 ||
    //     location.host.indexOf("localhost") != -1
    //   ) {
    //     urlList = "http://dev.cnknowledge.com/newtsgweb/?token="; //
    //   } else if (location.host.indexOf("yucard") != -1) {
    //     urlList = "http://yutsg.cnknowledge.com/newtsgweb?token="; //
    //   } else {
    //     urlList = "http://publish.cnknowledge.com/newtsgweb?token="; //
    //   }
    //   // var urlList =
    //   //   location.host.indexOf("cbtest.") != -1 || location.host.indexOf(":80") != -1
    //   //     ? "http://dev.cnknowledge.com/newtsgweb/?token="
    //   //     : "http://publish.cnknowledge.com/newtsgweb?token=";
    //   var perName = this.jous_list.name;
    //   var token = this.$store.state.token;
    //   if (token) {
    //     vm.$apis.manage.getUserInfo().then((res) => {
    //       var list_name;
    //       // var list_name = res.content.detail.userInfo.nickname
    //       //   ? res.content.detail.userInfo.nickname
    //       //   : res.content.detail.userInfo.realname
    //       //   ? res.content.detail.userInfo.realname
    //       //   : res.content.detail.userInfo.mobile;
    //       if (res.content.detail.userInfo) {
    //         if (res.content.detail.userInfo.nickname) {
    //           list_name = res.content.detail.userInfo.nickname;
    //         } else if (res.content.detail.userInfo.realname) {
    //           list_name = res.content.detail.userInfo.realname;
    //         } else if (res.content.detail.userInfo.mobile) {
    //           list_name = res.content.detail.userInfo.mobile;
    //         }
    //       } else {
    //         this.$Message.success("请完善您的个人信息");
    //         vm.listGive = true;
    //         return;
    //       }
    //       if (list_name) {
    //         // if (!res.content.detail.userInfo.idCard) {
    //         //   this.gitlist = true;
    //         //   return;
    //         // }
    //         if (this.jous_list.contribute == 0) {
    //           this.gitHave = true;
    //         } else {
    //           this.gitHave = false;
    //           if (vm.list_Data.editType == 1) {
    //             var mywin = window.open(
    //               `${urlList}&prid=${
    //                 this.$store.state.qikanId
    //               }#/manage/notice?perName=${perName}&name=${
    //                 vm.list_Data.name
    //               }&preliminaryId=${vm.list_Data.preliminaryId}&userId=${
    //                 vm.list_Data.userId
    //               }&solicitName=${""}`
    //             );
    //           } else if (vm.list_Data.editType == 2) {
    //             var mywin = window.open(
    //               `${urlList}&prid=${this.$store.state.qikanId}#/manage/notice?perName=${perName}&name=${vm.list_Data.dockingEditName}&solicitName=${vm.list_Data.name}&userId=${vm.list_Data.dockingEditId}&preliminaryId=${vm.list_Data.preliminaryId}&solicitId=${vm.list_Data.userId}`
    //             );
    //           }
    //           mywin.location.reload(true);
    //         }
    //       } else {
    //         this.$Message.success("请完善您的个人信息");
    //       }
    //     });
    //   } else {
    //     this.$root.Bus.$emit("analy", true);
    //     this.$Message.success("请登录您的用户");
    //   }
    //   // http://dev.cnknowledge.com/newtsgweb/?token=undefined&prid=1297783010043576320#/manage/author
    // },

    //期刊展示
    jourShow() {
      var data = {
        perId: this.$store.state.qikanId,
      };
      vm.$apis.manage.jourShow(data).then((res) => {
        vm.jous_list = res.content.vo;
        vm.coverImg = res.content.vo.coverImg;
        vm.jous_list.publishPeriod = vm.jous_list.publishPeriod
          ? vm.$global.publishPeriod(vm.jous_list.publishPeriod)
          : "";
      });
    },
  },
};
</script>
<style scoped lang="scss">
/deep/.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal {
    top: 0;
  }
}
/deep/.ivu-modal-footer {
  display: none;
}
.livest {
  padding: 20px 30px;
  line-height: 30px;
  max-height: 250px;
  min-height: 250px;
}
.git_have h3 {
  text-align: center;
  line-height: 50px;
}
.git_have button {
  margin: 30px auto;
  display: block;
}
.Bulletin {
  margin: 0 auto;
}
.economs {
  width: 100%;
  margin: 20px 0px;
  position: relative;
}
.flex_left {
  display: flex;
  justify-content: space-between;
}
.right_center {
  width: 600px;
  height: 305px;
  background: #ffffff;
  border: 1px solid #dcdcdc;
}
.paperFile {
  width: 100%;
  background: #ffffff;
  padding: 40px;
  margin-bottom: 20px;
}
.flex_left {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}
.kontribuo {
  width: 80%;
  padding-right: 40px;
}
.qikan_instar img {
  width: 230px;
  height: 270px;
  display: block;
  float: left;
  padding-right: 40px;
  padding-bottom: 30px;
}

.introduction {
  width: 100%;
  padding: 20px 15px;
  background: #f3f8fd;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.journal h3 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.journal h3 span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 30px;
  margin-left: 15px;
}
.contribute {
  cursor: pointer;
}
.contribute img {
  width: 60px;
  height: 60px;
  display: block;
  margin: 0px auto;
}
.contribute h3 {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #2150cb;
  line-height: 30px;
  text-align: center;
}
.contribute p {
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
}
.journal {
  padding-top: 35px;
  padding-left: 59px;
}
.journal p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 28px;
}
.right_kotribuo {
  width: 14%;
  margin-right: 20px;
  padding-top: 16%;
}
.right_kotribuo Button {
  width: 100px;
  height: 32px;
  background: #2150cb;
  display: block;
  margin: 14px auto;
  border-radius: 6px;
}
</style>
